import type { TutorialManifest } from "./types";

const MANIFEST_PATH = "/tutorials/manifest.json";

export class TutorialsService {
  fetchManifest = async (): Promise<TutorialManifest> => {
    const response = await fetch(
      `https://${import.meta.env.VITE_CLOUDFRONT_DOMAIN}${MANIFEST_PATH}`
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch tutorials manifest: ${response.status}`);
    }

    return (await response.json()) as TutorialManifest;
  };
}

/** Single instance + stable fetcher reference for SWR deduplication across renders. */
export const tutorialsService = new TutorialsService();

export const fetchTutorialManifest = (): Promise<TutorialManifest> =>
  tutorialsService.fetchManifest();
